export default __webpack_public_path__ + "static/media/navbar.9cfe4d37.png";